<template>
  <div class="detail-work-box">
    <div class="work-item">
      <div class="work-item-title border-bottom">
        <i class="iconfont">&#xe68c;</i>
        <span>营业执照</span>
      </div>
      <div class="license_img">
          <img :src="introduceInfo.businesslicense ? url + introduceInfo.businesslicense : defaultimg">
        </div>
    </div>
    <div class="work-item">
      <div class="work-item-title border-bottom">
        <i class="iconfont">&#xe68f;</i>
        <span>其他证件</span>
      </div>
      <div class="license_img license-other_img">
          <img v-show="introduceInfo.license1 !== ''" :src="introduceInfo.license1 ? url + introduceInfo.license1 : defaultimg">
          <img v-show="introduceInfo.license2 !== ''" :src="introduceInfo.license2 ? url + introduceInfo.license2 : defaultimg">
          <img v-show="introduceInfo.license3 !== ''" :src="introduceInfo.license3 ? url + introduceInfo.license3 : defaultimg">
        </div>
    </div>
  </div>
</template>

<script>
import url from '@/common/common.js'
export default {
  name: 'StoreCertificate',
  props: {
    introduceInfo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      url,
      errorDefaultImg: 'this.src="/static/img/defaultimg.jpg"',
      defaultimg: '/static/img/defaultimg.jpg' // 默认图片
    }
  }
}
</script>

<style scoped>
.work-item{
  background: #fff;
  box-shadow: 0px 1px 6px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
}
.detail-work-box>.work-item:first-child{
  margin-bottom: 10px;
}
.work-item-title{
  display: flex;
  align-items: center;
  padding: 12px 15px;
}
.work-item-title .iconfont{
  display: inline-block;
  margin-right: 6px;
  font-size: 14px;
  color: #FF8129;
}
work-item-title span{
  font-size: 13px;
  font-weight: bold;
  color: #333333;
}
.work-item-content{
  padding: 10px 15px 15px;
  font-size: 12px;
  font-weight: 400;
  line-height: 17px;
  color: #333333;
  text-indent: 2em;
}
.work-item-content-detail{
  padding: 15px;
}
.license_img{
  padding: 15px;
}
.license_img img{
  width: 100%;
}
.license-other_img img{
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/my_store/common/certificate/Certificate.vue